export const LOGIN = {
  LICENSE: '',
  PASSWORD: '',
  USER: '',
}
